import DomainEntity from '@/models/DomainEntity'

export default class StateTools extends DomainEntity {
  static get collectionName() {
    return 'statetools/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
